function insertSeparators(str, n, sep) {
	str = str.toString();
	sep = sep || ' ';
	let r = str.length % n,
		result = str.substr(0, r),
		pos = r;

	while (pos < str.length) {
		result += (result ? sep : '') + str.substr(pos, n);
		pos += n;
	}

	return result;
}

function formatPrice(price, useNbsp = false) {
	const s = price >= 0 ? 1 : -1;
	price *= s;
	return (
		insertSeparators(s * Math.floor(price / 100), 3, useNbsp ? '&nbsp;' : ' ') +
		',' +
		('' + (price % 100)).padStart(2, '0') +
		(useNbsp ? '&nbsp;zł' : ' zł')
	);
}

module.exports = {insertSeparators, formatPrice};
